const staging = {
  apiGateway: {
    REGION: "ap-southeast-1",
    URL: 'https://pwpb6wyz09.execute-api.ap-southeast-1.amazonaws.com/staging/api'
  },
  cognito: {
    REGION: "ap-southeast-1",
    USER_POOL_ID: "ap-southeast-1_rJ0zGgXtp",
    APP_CLIENT_ID: "jikucge3grdo9ajt4kb2rgic5",
    IDENTITY_POOL_ID: "ap-southeast-1:296fbefb-7494-41c4-bf7f-0a5d8db467a8"
  }
}
const dev = {
  apiGateway: {
    REGION: "ap-southeast-1",
    URL: 'https://zsgjketlsb.execute-api.ap-southeast-1.amazonaws.com/dev/api'
  },
  cognito: {
    REGION: "ap-southeast-1",
    USER_POOL_ID: "ap-southeast-1_rJ0zGgXtp",
    APP_CLIENT_ID: "jikucge3grdo9ajt4kb2rgic5",
    IDENTITY_POOL_ID: "ap-southeast-1:296fbefb-7494-41c4-bf7f-0a5d8db467a8"
  }
}
const local = {
  apiGateway: {
    REGION: "ap-southeast-1",
    URL: 'http://localhost:5000/api'
  },
  cognito: {
    REGION: "ap-southeast-1",
    USER_POOL_ID: "ap-southeast-1_rJ0zGgXtp",
    APP_CLIENT_ID: "jikucge3grdo9ajt4kb2rgic5",
    IDENTITY_POOL_ID: "ap-southeast-1:296fbefb-7494-41c4-bf7f-0a5d8db467a8"
  }
}
let config;

switch (process.env.REACT_APP_STAGE) {
  case 'dev':
    config = dev;
    break;
  case 'staging':
    config = staging;
    break;
  case 'local':
    config = local;
    break;
  default:
    break;
}
export default {
  ...config
};



// WEBPACK FOOTER //
// ./src/config_sample.js